const checkStatus = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
}

export default checkStatus
